<template>
  <div class="container-custom">
    <!-- Breadscrumbs -->
    <Breadscrumbs
      :links="[{ name: 'TechnologyCenter', to: { path: '/technology' } }]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>技術</h2>
      <v-spacer></v-spacer>
      <button class="btn btn-primary" @click="toTechnologyCreate">
        <v-icon class="mr-2 white--text">add</v-icon>
        <span>新增技術</span>
      </button>
    </div>
    <!-- block -->
    <div class="block mb-5">
      <TechnologyCenterTable></TechnologyCenterTable>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import TechnologyCenterTable from '@/views/E-7__Technology/c/TechnologyCenterTable.vue';

export default {
  components: {
    Breadscrumbs,
    TechnologyCenterTable,
  },
  created() {
    this.clear();
    this.getTechnologyList();
  },
  methods: {
    ...mapActions('technology', {
      getTechnologyList: 'find',
      clear: 'clear',
    }),
    toTechnologyCreate() {
      this.$router.push('/technology/create');
    },
  },
};
</script>

<style></style>
